import { getABTests } from '@/modules/ab_test/ab_test';
import type { ABTest, ABTestVariation } from '@/modules/ab_test/types';

export class ExperimentStore {
    getABTests(): ABTest[] {
        return getABTests();
    }

    isInExperiment(experimentKey: string, variation: ABTestVariation): boolean {
        const abTests = this.getABTests();
        const test = abTests.find((t) => t.experiment_key === experimentKey);
        return test?.variation_id === variation;
    }

    getExperimentVariation(experimentKey: string): ABTestVariation | null {
        const abTests = this.getABTests();
        const test = abTests.find((t) => t.experiment_key === experimentKey);
        return test?.variation_id ?? null;
    }

    isInControlGroup(experimentKey: string): boolean {
        return this.isInExperiment(experimentKey, 0);
    }

    isInTreatmentGroup(experimentKey: string): boolean {
        return this.isInExperiment(experimentKey, 1);
    }

    isParticipating(experimentKey: string): boolean {
        return this.getExperimentVariation(experimentKey) !== null;
    }
}
